import { g as gsapWithCSS } from "@theme/index";
class CategoriesMenu extends HTMLElement {
  connectedCallback() {
    this.init();
  }
  init() {
    this.categoryItems = this.querySelectorAll(".category-item");
    this.sideImageSets = this.querySelectorAll(".category-side-images");
    this.featuredContent = this.querySelectorAll(".category-featured-content");
    this.activeTimeline = null;
    this.currentCategoryIndex = "0";
    this.attachEventListeners();
    this.showImages("0");
  }
  attachEventListeners() {
    this.categoryItems.forEach((item) => {
      item.addEventListener("mouseenter", (e) => {
        const categoryIndex = e.currentTarget.getAttribute(
          "data-category-index"
        );
        this.showImages(categoryIndex);
      });
      item.addEventListener("click", (e) => {
        const categoryIndex = e.currentTarget.getAttribute(
          "data-category-index"
        );
        if (categoryIndex !== this.currentCategoryIndex) {
          this.showImages(categoryIndex);
        }
      });
    });
  }
  showImages(categoryIndex) {
    this.currentCategoryIndex = categoryIndex;
    this.categoryItems.forEach((item) => {
      item.classList.remove("active");
    });
    const activeItem = this.querySelector(
      `.category-item[data-category-index="${categoryIndex}"]`
    );
    if (activeItem) {
      activeItem.classList.add("active");
    }
    if (this.activeTimeline) {
      this.activeTimeline.kill();
    }
    this.activeTimeline = gsapWithCSS.timeline();
    const allArrows = this.querySelectorAll(".category-arrow");
    allArrows.forEach((arrow) => {
      this.activeTimeline.to(
        arrow,
        {
          opacity: 0,
          x: -10,
          duration: 0.2,
          ease: "power2.out"
        },
        0
      );
    });
    if (activeItem) {
      const activeArrow = activeItem.querySelector(".category-arrow");
      if (activeArrow) {
        this.activeTimeline.fromTo(
          activeArrow,
          {
            opacity: 0,
            x: -10
          },
          {
            opacity: 1,
            x: 0,
            duration: 0.3,
            ease: "power2.out"
          },
          0.1
        );
      }
    }
    this.sideImageSets.forEach((imageSet) => {
      if (imageSet.getAttribute("data-category-index") !== categoryIndex) {
        this.activeTimeline.to(
          imageSet,
          {
            opacity: 0,
            visibility: "hidden",
            duration: 0.2,
            ease: "power2.out"
          },
          0
        );
      }
    });
    this.featuredContent.forEach((content) => {
      if (content.getAttribute("data-category-index") !== categoryIndex) {
        this.activeTimeline.to(
          content,
          {
            opacity: 0,
            visibility: "hidden",
            duration: 0.2,
            ease: "power2.out"
          },
          0
        );
      }
    });
    const activeSideImages = this.querySelector(
      `.category-side-images[data-category-index="${categoryIndex}"]`
    );
    const activeFeaturedContent = this.querySelector(
      `.category-featured-content[data-category-index="${categoryIndex}"]`
    );
    if (activeSideImages) {
      const sideImageDivs = activeSideImages.querySelectorAll("div > div");
      this.activeTimeline.set(activeSideImages, { visibility: "visible" }, 0);
      this.activeTimeline.fromTo(
        activeSideImages,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 0.2,
          ease: "power2.out"
        },
        0.05
      );
      sideImageDivs.forEach((div, index) => {
        this.activeTimeline.fromTo(
          div,
          {
            clipPath: "inset(0 100% 0 0)",
            scale: 1.1
          },
          {
            clipPath: "inset(0 0% 0 0)",
            scale: 1,
            duration: 0.4,
            ease: "power3.out"
          },
          0.1 + index * 0.05
        );
      });
    }
    if (activeFeaturedContent) {
      const featuredImage = activeFeaturedContent.querySelector(".flex-1");
      const description = activeFeaturedContent.querySelector(".mt-4");
      const viewAllLink = activeFeaturedContent.querySelector(".mt-3");
      this.activeTimeline.set(
        activeFeaturedContent,
        { visibility: "visible" },
        0
      );
      this.activeTimeline.fromTo(
        activeFeaturedContent,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 0.2,
          ease: "power2.out"
        },
        0.05
      );
      if (featuredImage) {
        this.activeTimeline.fromTo(
          featuredImage,
          {
            clipPath: "inset(0 0 100% 0)",
            scale: 1.1
          },
          {
            clipPath: "inset(0 0 0% 0)",
            scale: 1,
            duration: 0.5,
            ease: "power3.out"
          },
          0.1
        );
      }
      if (description) {
        this.activeTimeline.fromTo(
          description,
          {
            opacity: 0,
            y: 20
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: "power2.out"
          },
          0.35
        );
      }
      if (viewAllLink) {
        this.activeTimeline.fromTo(
          viewAllLink,
          {
            opacity: 0,
            y: 20
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: "power2.out"
          },
          0.45
        );
      }
    }
  }
}
customElements.define("categories-menu", CategoriesMenu);
